import React, { PureComponent, lazy } from 'react';

import { Modal } from 'components/cosmos/v2/modal';
import { translate } from 'components/translate';
import withSuspense from 'hoc/withSuspense';
import PlayerReportStatistics from 'modules/player/retention/PlayerReportStatistics';
import PropTypes from 'prop-types';

import PlayerService from '../PlayerService';

const PlayerRetentionChart = withSuspense(
  lazy(() => import('./PlayerRetentionChart'))
);

class PlayerReportModal extends PureComponent {
  static propTypes = {
    mediaId: PropTypes.string,
    onClose: PropTypes.func
  };

  state = {
    data: {},
    loading: true
  };

  componentDidMount() {
    this.setData();
  }

  async setData() {
    const data = await PlayerService.fetchReport(this.props.mediaId);

    this.setState({ data, loading: false });
  }

  closeModal = (actions) => {
    const { onClose } = this.props;

    actions.closeModal();
    onClose && onClose();
  };

  render() {
    const { onClose, t } = this.props;
    const { audienceRetention, ...statistics } = this.state.data;

    return (
      <Modal
        show
        onClose={onClose}
        className="player__report__modal"
        aria-labelledby="player-report-modal-heading"
        role="dialog"
      >
        <Modal.Header
          className="_text-4 _text-gray-900 _font-weight-bold"
          id="player-report-modal-heading"
        >
          {t('embed_statistics_modal.title')}
        </Modal.Header>
        <Modal.Body>
          <p>{t('embed_statistics_modal.description')}</p>
          <div className="player__report__content">
            <PlayerRetentionChart
              loading={this.state.loading}
              mediaId={this.props.mediaId}
              audienceRetention={audienceRetention}
            />
            <PlayerReportStatistics statistics={statistics} />
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default translate()(PlayerReportModal);
